import React, { useState } from 'react';
import { X, Loader2, Sparkles } from 'lucide-react';

export default function VehicleModifyModal({ isOpen, onClose, sourceImage, currentTraining, onModify, isModifying }) {
  const [modifyPrompt, setModifyPrompt] = useState('');
  const [numImages, setNumImages] = useState(1);
  const [selectedOptions, setSelectedOptions] = useState([]);  // Multi-Select!
  const [customText, setCustomText] = useState('');  // Separater Custom-Text
  
  // Erkenne ob Avatar oder Vehicle
  const isAvatar = currentTraining?.training_type === 'avatar';
  const gender = currentTraining?.gender;
  const isFemale = gender === 'frau' || gender === 'woman';
  const isMale = gender === 'mann' || gender === 'man';
  
  // Avatar Modify Options - Frauen
  const avatarOptionsFemale = {
    'Frisur': [
      { label: 'Kürzer', value: 'shorter hair' },
      { label: 'Länger', value: 'longer hair' },
      { label: 'Glatt', value: 'straight hair' },
      { label: 'Gelockt', value: 'curly hair' },
      { label: 'Hochgesteckt', value: 'hair tied up' },
      { label: 'Offen', value: 'hair down' }
    ],
    'Haarfarbe': [
      { label: 'Blond', value: 'blonde hair' },
      { label: 'Braun', value: 'brown hair' },
      { label: 'Schwarz', value: 'black hair' },
      { label: 'Rot', value: 'red hair' },
      { label: 'Grau', value: 'grey hair' },
      { label: 'Highlights', value: 'hair with highlights' }
    ],
    'Outfit': [
      { label: 'Casual', value: 'casual outfit' },
      { label: 'Elegant', value: 'elegant outfit' },
      { label: 'Business', value: 'business outfit' },
      { label: 'Sportlich', value: 'sporty outfit' },
      { label: 'Abendkleid', value: 'evening dress' },
      { label: 'Streetstyle', value: 'streetstyle outfit' }
    ],
    'Make-up': [
      { label: 'Natürlich', value: 'natural makeup' },
      { label: 'Dezent', value: 'subtle makeup' },
      { label: 'Glamourös', value: 'glamorous makeup' },
      { label: 'Kein Make-up', value: 'no makeup' }
    ],
    'Brille': [
      { label: 'Brille hinzufügen', value: 'add eyeglasses' },
      { label: 'Brille entfernen', value: 'remove eyeglasses' },
      { label: 'Sonnenbrille', value: 'add sunglasses' }
    ],
    'Accessoires': [
      { label: 'Ohrringe', value: 'add earrings' },
      { label: 'Kette', value: 'add necklace' },
      { label: 'Armbanduhr', value: 'add wristwatch' },
      { label: 'Hut', value: 'add hat' }
    ],
    'Gesichtsausdruck': [
      { label: 'Lächelnd', value: 'smiling expression' },
      { label: 'Ernst', value: 'serious expression' },
      { label: 'Selbstbewusst', value: 'confident expression' },
      { label: 'Fröhlich', value: 'happy expression' }
    ],
    'Kleine Anpassungen': [
      { label: 'Gesicht aufhellen', value: 'brighten face slightly' },
      { label: 'Soft Beauty Light', value: 'add soft beauty lighting' },
      { label: 'Kopf leicht drehen', value: 'slightly turn head' }
    ]
  };
  
  // Avatar Modify Options - Männer
  const avatarOptionsMale = {
    'Frisur': [
      { label: 'Kürzer', value: 'shorter hair' },
      { label: 'Länger', value: 'longer hair' },
      { label: 'Moderner Schnitt', value: 'modern haircut' },
      { label: 'Undercut', value: 'undercut hairstyle' }
    ],
    'Haarfarbe': [
      { label: 'Blond', value: 'blonde hair' },
      { label: 'Braun', value: 'brown hair' },
      { label: 'Schwarz', value: 'black hair' },
      { label: 'Grau', value: 'grey hair' },
      { label: 'Highlights', value: 'hair with highlights' }
    ],
    'Outfit': [
      { label: 'Casual', value: 'casual outfit' },
      { label: 'Business', value: 'business outfit' },
      { label: 'Sportlich', value: 'sporty outfit' },
      { label: 'Elegant', value: 'elegant outfit' },
      { label: 'Streetwear', value: 'streetwear outfit' }
    ],
    'Bart': [
      { label: 'Bart entfernen', value: 'clean shaven, no beard' },
      { label: 'Dreitagebart', value: 'stubble beard' },
      { label: 'Vollbart', value: 'full beard' },
      { label: 'Schnurrbart', value: 'mustache' }
    ],
    'Brille': [
      { label: 'Brille hinzufügen', value: 'add eyeglasses' },
      { label: 'Brille entfernen', value: 'remove eyeglasses' },
      { label: 'Sonnenbrille', value: 'add sunglasses' }
    ],
    'Accessoires': [
      { label: 'Uhr', value: 'add wristwatch' },
      { label: 'Kette', value: 'add necklace' },
      { label: 'Mütze', value: 'add cap' }
    ],
    'Gesichtsausdruck': [
      { label: 'Lächelnd', value: 'smiling expression' },
      { label: 'Ernst', value: 'serious expression' },
      { label: 'Selbstbewusst', value: 'confident expression' }
    ],
    'Kleine Anpassungen': [
      { label: 'Gesicht aufhellen', value: 'brighten face slightly' },
      { label: 'Soft Shadow', value: 'add soft shadow' },
      { label: 'Kopf leicht drehen', value: 'slightly turn head' }
    ]
  };
  
  // Vehicle Modify Options (existing)
  const vehicleOptions = {
    'Styling': [
      { label: 'Farbe ändern', value: 'change to red color' },
      { label: 'Schwarze Felgen', value: 'add black rims and wheels' },
      { label: 'Chrome Felgen', value: 'add chrome rims and wheels' },
      { label: 'Racing Streifen', value: 'add racing stripes' },
      { label: 'Matte Lackierung', value: 'matte black finish' },
      { label: 'Spoiler', value: 'add rear spoiler' }
    ]
  };
  
  // Get options based on training type & gender
  const getModifyOptions = () => {
    if (isAvatar) {
      if (isFemale) return avatarOptionsFemale;
      if (isMale) return avatarOptionsMale;
      // Fallback: show both
      return {...avatarOptionsFemale, ...avatarOptionsMale};
    }
    return vehicleOptions;
  };
  
  const modifyOptions = getModifyOptions();
  
  const handleQuickSelect = (optionLabel, optionValue) => {
    // Multi-Select Toggle
    const isSelected = selectedOptions.some(opt => opt.value === optionValue);
    
    let newSelected;
    if (isSelected) {
      // Remove if already selected
      newSelected = selectedOptions.filter(opt => opt.value !== optionValue);
    } else {
      // Add to selection
      newSelected = [...selectedOptions, { label: optionLabel, value: optionValue }];
    }
    
    setSelectedOptions(newSelected);
    
    // Build Modify prompt from all selected options
    if (newSelected.length > 0) {
      const changes = newSelected.map(opt => opt.value).join(', ');
      const modifyPrefix = 'Modify: Change to';
      const modifySuffix = 'while keeping pose, background, and composition identical';
      setModifyPrompt(`${modifyPrefix} ${changes} ${modifySuffix}`);
    } else {
      setModifyPrompt(customText);
    }
  };
  
  const handleSubmit = () => {
    if (!modifyPrompt?.trim()) {
      alert('Bitte beschreibe die gewünschte Änderung');
      return;
    }
    // Pass selected options as metadata
    onModify(modifyPrompt, numImages, selectedOptions);
  };
  
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-gradient-to-br from-[#0A0E1A] to-[#111827] border border-white/20 rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl">
        
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-br from-white/10 to-transparent backdrop-blur-xl border-b border-white/10 p-6 flex items-center justify-between z-20">
          <div>
            <h3 className="text-2xl font-bold text-white mb-1">Bild modifizieren</h3>
            <p className="text-amber-400 text-sm">🔧 Nur Details ändern – Original-Szene bleibt erhalten</p>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 bg-white/10 backdrop-blur-xl border border-white/20 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors duration-150"
            disabled={isModifying}
          >
            <X className="w-5 h-5 text-white" />
          </button>
        </div>
        
        {/* Handle-Strich */}
        <div className="w-16 h-1 bg-white/20 rounded-full mx-auto mt-6"></div>
        
        {/* Content */}
        <div className="p-6">
          
          {/* Source Image Preview */}
          {sourceImage && (
            <div className="mb-6">
              <p className="text-sm text-gray-400 mb-3">Original-Bild:</p>
              <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-3">
                <img 
                  src={sourceImage} 
                  alt="Original" 
                  className="w-full max-h-64 object-contain rounded-xl"
                />
              </div>
            </div>
          )}
          
          {/* Modify Categories - Clean Pills Design */}
          <div className="mb-6">
            <p className="text-sm font-medium text-gray-300 mb-4">Schnellauswahl:</p>
            
            {/* Categories */}
            <div className="space-y-6">
              {Object.entries(modifyOptions).map(([category, options]) => (
                <div key={category}>
                  <p className="text-xs font-semibold text-cyan-400 mb-3 uppercase tracking-wide">{category}</p>
                  <div className="flex flex-wrap gap-2">
                    {options.map((option, idx) => (
                      <button
                        key={idx}
                        onClick={() => handleQuickSelect(option.label, option.value)}
                        className={`px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 ${
                          selectedOptions.some(opt => opt.value === option.value)
                            ? 'bg-gradient-to-r from-cyan-500 to-teal-500 text-black shadow-lg shadow-cyan-500/30'
                            : 'bg-white/5 border border-white/10 text-gray-300 hover:bg-white/10 hover:border-cyan-400/30'
                        }`}
                      >
                        {option.label}
                      </button>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Ausgewählte Änderungen - Vorschau */}
          {selectedOptions.length > 0 && (
            <div className="mb-6 p-4 bg-cyan-500/10 backdrop-blur border border-cyan-400/30 rounded-xl">
              <p className="text-cyan-300 font-semibold text-sm mb-2">Ausgewählte Änderungen:</p>
              <div className="flex flex-wrap gap-2">
                {selectedOptions.map((opt, idx) => (
                  <span key={idx} className="px-3 py-1.5 bg-cyan-500/20 border border-cyan-400/40 rounded-full text-cyan-200 text-xs font-medium">
                    {opt.label}
                  </span>
                ))}
              </div>
            </div>
          )}
          
          {/* Custom Modification Prompt */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-300 mb-3">
              Oder eigene Änderung beschreiben:
            </label>
            <textarea
              value={customText}
              onChange={(e) => {
                setCustomText(e.target.value);
                // Wenn Custom Text eingegeben wird, überschreibt er die Button-Auswahl
                if (e?.target?.value?.trim()) {
                  setModifyPrompt(e.target.value);
                } else {
                  // Zurück zu Button-generierten Prompt
                  if (selectedOptions.length > 0) {
                    const changes = selectedOptions.map(opt => opt.value).join(', ');
                    setModifyPrompt(`Modify: Change to ${changes} while keeping pose, background, and composition identical`);
                  } else {
                    setModifyPrompt('');
                  }
                }
              }}
              placeholder={isAvatar ? "z.B. kürzere Haare, Sonnenbrille hinzufügen..." : "z.B. rote Farbe mit schwarzen Felgen..."}
              className="w-full px-5 py-4 bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl text-white placeholder:text-gray-500 focus:border-cyan-400/50 focus:ring-2 focus:ring-cyan-400/20 transition-colors duration-150 resize-none"
              rows={4}
            />
            <div className="text-gray-400 text-xs mt-3 bg-amber-500/10 border border-amber-500/30 rounded-lg p-3">
              <span className="text-amber-400 font-semibold">🔧 MODIFY = Nur Details ändern!</span><br/>
              <span className="text-gray-300">
                {isAvatar 
                  ? 'Behält Original-Szene bei. Ändere nur Frisur, Outfit, Accessoires – KEINE neuen Hintergründe oder Posen.' 
                  : 'Behält Original-Szene bei (Parkplatz, Haus, etc.). Ändere nur Farbe, Felgen, Aufkleber – KEINE neuen Umgebungen.'}
              </span>
            </div>
          </div>

          {/* Anzahl Bilder Selector */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-white mb-3">
              Anzahl Bilder
            </label>
            <select
              value={numImages}
              onChange={(e) => setNumImages(parseInt(e.target.value))}
              className="w-full p-4 bg-white/10 backdrop-blur-xl border border-white/20 rounded-xl text-white font-medium focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-all appearance-none cursor-pointer"
              style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2306b6d4'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 1rem center',
                backgroundSize: '1.5em'
              }}
            >
              <option value={1} className="bg-[#1A1A1A]">1 Bild</option>
              <option value={2} className="bg-[#1A1A1A]">2 Bilder</option>
              <option value={3} className="bg-[#1A1A1A]">3 Bilder</option>
              <option value={4} className="bg-[#1A1A1A]">4 Bilder</option>
            </select>
          </div>

          
          {/* Action Buttons */}
          <div className="flex gap-4">
            <button
              onClick={onClose}
              disabled={isModifying}
              className="px-8 py-4 bg-white/10 backdrop-blur border border-white/20 text-white rounded-full hover:bg-white/20 disabled:opacity-50 transition-colors duration-150 font-medium"
            >
              Abbrechen
            </button>
            <button
              onClick={handleSubmit}
              disabled={isModifying || !modifyPrompt?.trim()}
              className={`flex-1 py-4 rounded-full font-semibold text-base flex items-center justify-center gap-2 transition-all duration-300 ${
                isModifying || !modifyPrompt?.trim()
                  ? 'bg-white/10 text-white/40 cursor-not-allowed'
                  : 'bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:shadow-xl hover:shadow-purple-500/40 hover:scale-105 shadow-lg shadow-purple-500/30'
              }`}
            >
              {isModifying ? (
                <><Loader2 className="w-5 h-5 animate-spin" /> Modifiziere...</>
              ) : (
                <><Sparkles className="w-5 h-5" /> Änderung generieren</>
              )}
            </button>
          </div>
          
        </div>
        
      </div>
    </div>
  );
}
